import * as React from 'react';
import { LogoProps } from '../Logo';

const GrantThorntonLogo: React.FunctionComponent<LogoProps> = ({ compact, className }: LogoProps) =>
    compact ? (
        <svg viewBox="0 0 170.57 170.56" width={36} className={className}>
            <path
                d="m85.284 53.5c12.957 4.1222 23.223 13.779 30.2 27.491a9.7345 9.7345 0 0 1 0.8999 6.2219c0.24191-0.64832 0.46447-1.287 0.66767-1.9353 16.634-52.253-42.276-87.339-72.176-71.605-0.57091 0.31932-1.1515 0.61929-1.7127 0.96765a82.249 82.249 0 0 0-29.561 111.06c-15.656-29.9 19.353-88.829 71.683-72.196z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m53.524 85.27c4.1125-12.957 13.77-23.223 27.481-30.19a9.8119 9.8119 0 0 1 6.2219-0.90958c-0.63863-0.24192-1.287-0.4548-1.9353-0.66768-52.253-16.624-87.339 42.276-71.605 72.186 0.30964 0.57091 0.61929 1.1418 0.96764 1.7127a82.249 82.249 0 0 0 111.12 29.523c-29.929 15.695-88.887-19.362-72.254-71.654z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m85.294 117.03c-12.957-4.1222-23.223-13.779-30.2-27.491a9.7345 9.7345 0 0 1-0.8999-6.2219c-0.24191 0.64832-0.46447 1.287-0.66767 1.9353-16.634 52.253 42.276 87.339 72.176 71.654 0.5709-0.31932 1.1515-0.62896 1.7127-0.96764a82.249 82.249 0 0 0 29.523-111.11c15.695 29.91-19.353 88.839-71.644 72.205z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m117.04 85.27c-4.1125 12.957-13.77 23.223-27.491 30.19a9.6764 9.6764 0 0 1-6.2122 0.90958q0.96764 0.34835 1.9353 0.66767c52.253 16.624 87.33-42.276 71.605-72.186-0.30965-0.57091-0.6193-1.1418-0.96764-1.7127a82.249 82.249 0 0 0-111.07-29.523c29.91-15.695 88.829 19.362 72.196 71.654z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
        </svg>
    ) : (
        <svg width="160" height="73" viewBox="0 0 1084.9 493.08" className={className}>
            <title>grandthorton</title>
            <path
                d="m170.32 166.97c12.957 4.1222 23.223 13.779 30.2 27.491a9.7345 9.7345 0 0 1 0.8999 6.2219c0.24191-0.64832 0.46447-1.287 0.66767-1.9353 16.634-52.253-42.276-87.339-72.176-71.605-0.57091 0.31932-1.1515 0.61929-1.7127 0.96765a82.249 82.249 0 0 0-29.561 111.06c-15.656-29.9 19.353-88.829 71.683-72.196z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m138.56 198.74c4.1125-12.957 13.77-23.223 27.481-30.19a9.8119 9.8119 0 0 1 6.2219-0.90958c-0.63863-0.24192-1.287-0.4548-1.9353-0.66768-52.253-16.624-87.339 42.276-71.605 72.186 0.30964 0.57091 0.61929 1.1418 0.96764 1.7127a82.249 82.249 0 0 0 111.12 29.523c-29.929 15.695-88.887-19.362-72.254-71.654z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m170.33 230.5c-12.957-4.1222-23.223-13.779-30.2-27.491a9.7345 9.7345 0 0 1-0.8999-6.2219c-0.24191 0.64832-0.46447 1.287-0.66767 1.9353-16.634 52.253 42.276 87.339 72.176 71.654 0.5709-0.31932 1.1515-0.62896 1.7127-0.96764a82.249 82.249 0 0 0 29.523-111.11c15.695 29.91-19.353 88.839-71.644 72.205z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="m202.08 198.74c-4.1125 12.957-13.77 23.223-27.491 30.19a9.6764 9.6764 0 0 1-6.2122 0.90958q0.96764 0.34835 1.9353 0.66767c52.253 16.624 87.33-42.276 71.605-72.186-0.30965-0.57091-0.6193-1.1418-0.96764-1.7127a82.249 82.249 0 0 0-111.07-29.523c29.91-15.695 88.829 19.362 72.196 71.654z"
                style={{
                    fill: 'none',
                    strokeWidth: 6,
                    stroke: '#fff',
                }}
            />
            <path
                d="M440,233.81c-8.37,0-11.51-3.66-11.51-9.55,0-6.81,3.79-10.34,13.74-10.34h13.09v3.92C455.27,228.18,448.85,233.81,440,233.81Zm-22.77-8.51c0,8.12,4.71,16.76,19.37,16.76,8.51,0,14.4-3.27,18.46-8.51l1.44,7.2h9.16V202c0-16.62-9.95-19.5-21.73-19.5-8.9,0-20.55,2.61-23.43,16h11.26c1.44-5,4.84-7.85,12-7.85,5.89,0,11.52,2.09,11.52,11.51v4.06H442.84c-14.93,0-25.66,5-25.66,19.11Zm-30,15.45h10.61v-35.6c0-8.25,5.1-12.05,11.65-12.05a40,40,0,0,1,6.8.53V183.28a17.25,17.25,0,0,0-5.62-.78,14.18,14.18,0,0,0-12.83,8.38l-1.31-6.94h-9.3Zm376,0h10.61v-35.6c0-8.25,5.1-12.05,11.64-12.05a40.19,40.19,0,0,1,6.82.53V183.28a17.34,17.34,0,0,0-5.63-.78,14.18,14.18,0,0,0-12.83,8.38l-1.31-6.94h-9.3ZM563.9,193.23v-9.29H552.26V167.71l-10.86,1.7v14.53h-8.25v9.29h8.25v36.13c0,8.12,3,13,14.92,13a39.15,39.15,0,0,0,8.9-1.18V233a26.06,26.06,0,0,1-6.54.78c-5,0-6.42-2.35-6.42-7.59v-33Zm319.87,0v-9.29H872.12V167.71l-10.86,1.7v14.53H853v9.29h8.25v36.13c0,8.12,3,13,14.92,13a39.15,39.15,0,0,0,8.9-1.18V233a26.06,26.06,0,0,1-6.54.78c-5,0-6.42-2.35-6.42-7.59v-33Zm-158,40.19c-10.21,0-16.76-7.07-16.76-21.2,0-13.49,6.81-21.08,16.9-21.08s16.22,7.46,16.22,21.73c0,13.74-6.28,20.55-16.36,20.55Zm189.67,0c-10.21,0-16.76-7.07-16.76-21.2,0-13.49,6.81-21.08,16.89-21.08s16.22,7.46,16.22,21.73c0,13.74-6.27,20.55-16.35,20.55Zm-115.84,7.33H810V208c0-9.43,4-16,13.87-16,9.16,0,12,3.93,12,13.49v35.21h10.6V202.53c0-13.09-5.51-19.9-17.93-19.9-8.51,0-14.79,3.14-18.59,8.51l-1.31-7.2h-9Zm-320.26,0h10.34V208c0-9.43,4.06-16,13.88-16,9.16,0,12,3.93,12,13.49v35.21h10.6V202.53c0-13.09-5.49-19.9-17.93-19.9-8.51,0-14.79,3.14-18.59,8.51l-1.3-7.2h-9Zm473.66,0h10.34V208c0-9.43,4.06-16,13.87-16,9.16,0,12,3.93,12,13.49v35.21h10.6V202.53c0-13.09-5.49-19.9-17.93-19.9-8.51,0-14.8,3.14-18.59,8.51l-1.31-7.2h-9ZM636.38,164.44v-9.17H575.91v9.17h24.74v76.31H612V164.44Zm5.5,76.31h10.35V208c0-9.43,4-16,13.87-16,9.16,0,12,3.93,12,13.49v35.21h10.6V202.53c0-13.09-5.5-19.9-17.93-19.9-8.51,0-14.79,3.14-18.58,8.51V155.27H641.88Zm-297.22-33.9h20.16v19c-6.15,5.37-15.58,7.46-23.17,7.46-19,0-29.84-12.31-29.84-33.91,0-22.9,11.65-35.6,29.58-35.6,10.74,0,18.72,3.8,26.31,11l6.68-7.6c-6.81-7.46-18.46-13-31.81-13-26.83,0-42.67,18.71-42.67,44.89,0,25.66,13.22,43.46,41.88,43.46,15.84,0,28.15-6.94,34.17-13.48v-31H344.66ZM726.57,182.5c-18.85,0-28.67,13-28.67,30.11,0,17.67,9.82,29.45,27.36,29.45s28.4-11.52,28.4-29.72c0-18.71-10.08-29.84-27.09-29.84Zm189.67,0c-18.86,0-28.68,13-28.68,30.11,0,17.67,9.82,29.45,27.36,29.45s28.41-11.52,28.41-29.72c0-18.71-10.08-29.84-27.09-29.84Z"
                fill="#fff"
            />
            <path
                d="m352.4 382.64-6.68-17.89h-21.62l-6.25 17.89h-8l20.59-56.64h8.94l21 56.69zm-17.71-48.79-8.59 24.74h17.45z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m365.59 345h6.25l0.78 4.78c2.43-3.56 6.51-5.65 12.07-5.65 8.24 0 12.06 4.43 12.06 13v25.52h-7v-23.36c0-6.25-2-9-8.07-9-6.6 0-9 4.43-9 10.68v21.62h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m425.48 329.08h6.95v7.81h-6.95zm0 15.88h6.95v37.68h-6.95z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m441.89 345h6.25l0.78 4.78c2.43-3.56 6.51-5.65 12.06-5.65 8.25 0 12.07 4.43 12.07 13v25.52h-7v-23.36c0-6.25-2-9-8.07-9-6.6 0-9 4.43-9 10.68v21.62h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m481.73 374.13a22.26 22.26 0 0 0 10.85 3.3c4 0 7.12-1 7.12-4.95 0-3.73-2.95-5-8.16-6.08-6.34-1.39-11.46-3.47-11.46-10.85s5.47-11.28 13.37-11.28a21.55 21.55 0 0 1 12.55 3.73l-3.12 5a17.11 17.11 0 0 0-9.29-3c-3.65 0-6.42 1.21-6.42 4.86s3.21 4.69 7.46 5.73c6.16 1.47 12.15 3.64 12.15 11.11 0 7.64-5.72 11.63-14 11.63a28.49 28.49 0 0 1-13.48-3.33z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m523.39 351.13v21.78c0 3.39 1 4.95 4.34 4.95a15.72 15.72 0 0 0 4.17-0.52v5.38a23.74 23.74 0 0 1-5.73 0.78c-8 0-9.9-3.12-9.9-8.59v-23.78h-5.55v-6.13h5.55v-9.55l7.12-1.21v10.76h7.73v6.17z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m540.14 329.08h7v7.81h-7zm0 15.88h7v37.68h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m556.55 345h6.25l0.78 4.78c2.43-3.56 6.51-5.65 12.06-5.65 8.25 0 12.07 4.43 12.07 13v25.52h-7v-23.36c0-6.25-2-9-8.07-9-6.6 0-9 4.43-9 10.68v21.62h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m623 374.48 2.78 5.29a24.17 24.17 0 0 1-13.29 3.91c-12.84 0-18.31-8.42-18.31-19.27 0-12.24 6.42-20.14 18.23-20.14a15.69 15.69 0 0 1 14 7.64l-4.68 3.73c-2.61-3.56-5.56-5.47-9.55-5.47-6.25 0-10.42 4.43-10.42 13.72 0 8.24 3.91 13.89 11.37 13.89 3.75 0 6.78-1.31 9.87-3.3z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m642.65 351.13v21.78c0 3.39 1 4.95 4.34 4.95a15.72 15.72 0 0 0 4.17-0.52v5.38a23.74 23.74 0 0 1-5.73 0.78c-8 0-9.9-3.12-9.9-8.59v-23.78h-5.53v-6.13h5.55v-9.55l7.12-1.21v10.76h7.73v6.17z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m696.38 345v6.34h-8.33v31.34h-6.95v-31.38h-5.55v-6.3h5.55v-8.07c0-6 2.52-11.72 10.68-11.72a28.83 28.83 0 0 1 7 1v5.46a28.1 28.1 0 0 0-4.6-0.52c-4.69 0-6.16 1.65-6.16 6.25v7.6z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m735.79 363.89c0 12-7.21 19.61-18.84 19.61s-18.14-7.89-18.14-19.53c0-11.28 6.42-20 19.1-20 11.28 0.03 17.88 7.42 17.88 19.92zm-7.55 0.34c0-9.46-4.17-14.49-10.85-14.49s-11.29 5-11.29 14.06c0 9.37 4.43 14 11.2 14 6.6-0.02 10.94-4.45 10.94-13.57z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m742 345h6l1 4.52a9.25 9.25 0 0 1 8.68-5.47 12.07 12.07 0 0 1 3.56 0.43v6.95a23.84 23.84 0 0 0-4.24-0.43c-4.43 0-7.9 2.52-7.9 7.9v23.7h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m814.86 381.16c0 12.41-7 17.8-18.66 17.8a36.64 36.64 0 0 1-12.59-1.91v-6.05a39.81 39.81 0 0 0 12.24 2.08c8.51 0 12.07-3.9 12.07-12.24v-2.08c-2.34 3-7.12 4.95-11.29 4.95-11.45 0-16.49-7.38-16.49-19 0-13.11 6.77-20.4 17.1-20.4 4.26 0 8.86 1.65 11.29 3.9l0.6-3.21h5.73zm-6.94-27c-1.82-2.34-6-4.16-9.55-4.16-7 0-10.68 5-10.68 14.32 0 10 4 13.8 10.16 13.8 5.47 0 10.07-4.34 10.07-9z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m821.8 345h6l1.05 4.52a9.24 9.24 0 0 1 8.68-5.47 12.07 12.07 0 0 1 3.56 0.43v6.95a23.84 23.84 0 0 0-4.34-0.35c-4.43 0-7.9 2.52-7.9 7.9v23.7h-7z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m880.48 363.89c0 12-7.2 19.61-18.83 19.61s-18.15-7.89-18.15-19.5c0-11.28 6.43-20 19.1-20 11.29 0 17.88 7.39 17.88 19.89zm-7.55 0.34c0-9.46-4.16-14.49-10.85-14.49s-11.28 5-11.28 14.06c0 9.37 4.42 14 11.2 14 6.59-0.02 10.93-4.45 10.93-13.57z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m882 345h7.64l8 28.91 8.01-28.91h7l7.46 28.48 8.2-28.48h7l-11.38 37.68h-8.07l-6.94-27-7.82 27h-7.81z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m952.79 351.13v21.78c0 3.39 1 4.95 4.34 4.95a15.65 15.65 0 0 0 4.16-0.52v5.38a23.67 23.67 0 0 1-5.73 0.78c-8 0-9.89-3.12-9.89-8.59v-23.78h-5.56v-6.13h5.56v-9.55l7.12-1.21v10.76h7.72v6.17z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m968.67 326h6.94v23.79c2.52-3.56 6.77-5.65 12.33-5.65 8.07 0 11.72 4.43 11.72 13v25.52h-7v-23.37c0-6.25-1.83-9-7.81-9-6.6 0-9.21 4.43-9.21 10.68v21.62h-6.94z"
                style={{
                    fill: '#fff',
                }}
            />
            <path
                d="m1008.2 316.83h-3.31v9.17h-1.74v-9.15h-3.31v-1.41h8.36zm13.78 9.17h-1.75v-8.82l-3.46 8.82h-1.11l-3.46-8.82v8.82h-1.74v-10.58h2.69l3.15 8 3.11-8h2.57z"
                style={{
                    fill: '#fff',
                }}
            />
            <rect
                x="312.15"
                y="282.42"
                width="687.72"
                height="2"
                style={{
                    fill: '#fff',
                }}
            />
        </svg>
    );

export default GrantThorntonLogo;
